import { API } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactJson from "react-json-view";

function ContactBookMain() {
  const params = useParams();
  const [contactBook, setContactBook] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContactBook();
  }, []);

  const mappingContactBook = (contactBook = []) => {
    const contactBookMap = contactBook.map((contact) => {
      const mapPhone = contact?.phone
        ?.map(
          (contactPhone) =>
            `${contactPhone?.label} ${String(
              contactPhone?.number
            ).replace(/ /g, "")}`
        )
        .join(", ");

      return `${contact?.name} ${contact?.lastname} - ${mapPhone} ${contact?.favorite || ""}`;
    });
    return contactBookMap;
  };

  const fetchContactBook = async () => {
    try {
      setLoading(true);
      const data = await API.get(
        "MoneyHubAdmin",
        `/contactBook/${params?.citizenid}`
      );
      setContactBook(mappingContactBook(data?.contactBook));
    } catch (error) {
      console.log("error contact book", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <ReactJson
        src={contactBook}
        name={false}
        enableClipboard={false}
        displayObjectSize={false}
        displayDataTypes={false}
        groupArraysAfterLength={9999}
      />
    </div>
  );
}

export default ContactBookMain;
